import React, { useState } from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import { createInternal } from '../../../axios/InternalAxios';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import LoadingOverlay from '../../../components/LoadingOverlay';

function InternalAdd() {
  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Internal', href: '/internal' },
    { label: 'Create Internal' },
  ];

  const navigation = useNavigate();

  const [formData, setFormData] = useState({
    internal_code: '',
    first_name: '',
    last_name: '',
    title: '',
    extension: '',
    work_phone: '',
    address: '',
    city: '',
    state_or_province: '',
    postal_code: '',
    country: '',
    email: '',
    phone: '',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    if (!form.checkValidity()) {
      form.classList.add('was-validated');
      return;
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
        denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
        cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
      },
      buttonsStyling: false,
    });

    try {
      const result = await swalWithBootstrapButtons.fire({
        title: 'Do you want to save the data?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: `Don't save`,
      });

      if (result.isConfirmed) {
        try {
          // Coba buat akun
          setMessage('Saving data...');
          setLoading(true);
          await createInternal(formData);
          // Jika berhasil, tampilkan pesan sukses
          swalWithBootstrapButtons.fire(
            'Saved!',
            'The internal has been created.',
            'success'
          );
          navigation('/internal');
        } catch (createAccountError) {
          // Jika ada kesalahan saat membuat akun, tampilkan pesan kesalahan
          swalWithBootstrapButtons.fire({
            title: 'Error!',
            text: createAccountError.message,
            icon: 'error',
          });
        } finally {
          setLoading(false);
        }
      } else if (result.isDenied) {
        swalWithBootstrapButtons.fire('Changes are not saved', '', 'info');
      }
    } catch (error) {
      swalWithBootstrapButtons.fire({
        title: 'Error!',
        text: 'There was an error processing your request.',
        icon: 'error',
      });
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const formElements = Array.from(e.target.form.elements);
      const index = formElements.indexOf(e.target);
      formElements[index + 1]?.focus();
    }
  };
  const handleCancel = (event) => {
    event.preventDefault();

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
        denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
        cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: 'All your input will be lost!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, cancel it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.isConfirmed) {
          const form = document.querySelector('.needs-validation');
          form.reset();
          setFormData({
            internal_code: '',
            first_name: '',
            last_name: '',
            title: '',
            extension: '',
            work_phone: '',
            address: '',
            city: '',
            state_or_province: '',
            postal_code: '',
            country: '',
            email: '',
            phone: '',
          });
          form.classList.remove('was-validated');
        }
      });
  };
  return (
    <div>
      <LoadingOverlay show={loading} message={message} />
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>
      <form
        className="needs-validation"
        noValidate
        autocomplete="off"
        onSubmit={handleSubmit}
      >
        <div className="row">
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="validationAccCode" className="form-label">
                    Internal Code
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationAccCode"
                    name="internal_code"
                    value={formData.internal_code}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="validationAccCode"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    required
                  />
                  <div className="invalid-feedback">Cannot be empty.</div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Title</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Extension</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="extension"
                    value={formData.extension}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Work Phone</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="work_phone"
                    value={formData.work_phone}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Postal Code</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="postal_code"
                    value={formData.postal_code}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">State or Province</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="state_or_province"
                    value={formData.state_or_province}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Country</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email Address</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
            <div className="button-navigatsi">
              <div className="">
                <button type="submit" className="btn btn-primary">
                  <i className="bi bi-send"></i>
                  <span> Submit</span>
                </button>
              </div>
              <div className="">
                <button
                  type="reset"
                  className="btn btn-danger btn-cancel"
                  onClick={handleCancel}
                >
                  <i className="bi bi-x-circle"></i>
                  <span> Cancel</span>
                </button>
              </div>
              <div className="">
                <Link type="button" className="btn btn-warning" to="/internal">
                  <i className="bi bi-arrow-left-circle"></i>
                  <span> Back</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default InternalAdd;
